import {
  AdminApplication,
  ApplicationFromApi,
  GetApplicationByIdArgs,
  UpdateApplicationCallbackArgs,
  GetApplicationsReturnType,
  AppGroup,
  CreateAdminApplicationArgs,
  CreateClientApplicationArgs,
} from './types';
import api from '../api/slice';

const applicationsApi = api.injectEndpoints({
  endpoints: builder => ({
    getUserApplications: builder.query<GetApplicationsReturnType, void>({
      query: () => '/application',
      transformResponse: (response: AppGroup[]) => {
        return {
          appGroups: response,
          applications: response.map(appGroup => appGroup.applications).flat(),
        };
      },
    }),
    getApplicationDetails: builder.query<ApplicationFromApi, GetApplicationByIdArgs>({
      providesTags: (result, error, arg) => [{ type: 'applications', id: arg.appId }],
      query: ({ appId }) => {
        return {
          url: `${appId}/application`,
        };
      },
    }),
    getAllAdminApplications: builder.query<AdminApplication[], void>({
      query: () => ({
        url: '/app-creation/admin',
      }),
      providesTags: ['adminApplications'],
    }),
    updateApplicationCallback: builder.mutation<{ RowsAffected: number }, UpdateApplicationCallbackArgs>({
      query: ({ appId, ...args }) => {
        return {
          url: `${appId}/application/callback`,
          method: 'PUT',
          body: {
            CallbackURL: args.callbackURL,
            CallbackKey: args.callbackKey,
            CallbackVersion: args.callbackVersion,
          },
        };
      },
      invalidatesTags: (result, error, arg) => [{ type: 'applications', id: arg.appId }],
    }),
    createAdminApplication: builder.mutation<{ applicationId: number }, CreateAdminApplicationArgs>({
      query: args => {
        return {
          url: '/app-creation/admin',
          method: 'POST',
          body: args.body,
        };
      },
      // Refresh the Company list so a newly created partner can be selected straight away.
      invalidatesTags: ['adminApplications'],
    }),
    createClientApplication: builder.mutation<{ applicationId: number }, CreateClientApplicationArgs>({
      query: args => {
        return {
          url: '/app-creation/client',
          method: 'POST',
          body: args.body,
        };
      },
    }),
  }),
});

export const {
  useGetUserApplicationsQuery,
  useGetApplicationDetailsQuery,
  useGetAllAdminApplicationsQuery,
  useUpdateApplicationCallbackMutation,
  useCreateAdminApplicationMutation,
  useCreateClientApplicationMutation,
} = applicationsApi;
export default applicationsApi;
